exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".automation-result-action-icons .icon-wrapper[data-v-38b3f3da] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}", ""]);

// exports
